import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#7540ee",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.429",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "m18.929 13.371-5.557 5.557a1.07 1.07 0 0 1-1.515 0l-9.3-9.3a.51.51 0 0 1-.157-.414l.843-5.486a.53.53 0 0 1 .486-.485L9.214 2.4a.51.51 0 0 1 .415.157l9.3 9.3a1.07 1.07 0 0 1 0 1.514M5.758 5.757l-5-5" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }